import React, { useEffect } from 'react'
import styled from '@emotion/styled';
import { Box, Grid } from '@mui/material';
import Paragraph from '../../Components/Paragraph';
import Heading from '../../Components/Heading';
import { Markee } from '../../Components/Markee';
import { Markee2 } from '../../Components/Markee2';
import Aos from 'aos';
const Wrapper = styled(Box)`
padding: 120px 0px 40px 0px;
`;
const Partners = () => {
    useEffect(() => {
        
            Aos.init({
              duration: 1200,
              offset: 100,
              once: true, 
              easing: 'ease-out-cubic',
              mirror: false,
            });
          }, []);
  return (
    <Wrapper >
           <Grid container  justifyContent={'center'} textAlign={'center'} data-aos="fade-up" data-aos-once="false">
         <Grid item style={{marginBottom:'50px'}}>
        <Heading style={{marginBottom:'20px'}} data-aos="fade-up">
          Our{' '}
            <span style={{
            background: "linear-gradient(128deg, rgb(255 255 255) 52%, rgb(168, 96, 255)) text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontWeight: 'bolder'
            }}>
        Partners
            </span>
        </Heading>
      </Grid>
      <Markee/>
      {/* <Markee2/> */}
    </Grid>
    </Wrapper>
  )
}

export default Partners